<template>
  <div :class="rootClass">
    <div v-if="isShowErrNoti" class="font-medium-4 errMsg">
      <div class="d-flex flex-column">
        <img src="@/assets/images/icons/x-circle.svg"
             style="width: 100px;height: 100px;margin-left: 40%;margin-bottom: 5%">
        <p style="font-size: 21px;font-weight: 700;line-height: 36px;text-align: center;">{{ notiContent }}</p>
        <button class="buttonOK" style="margin-left: 30%;" @click="isShowErrNoti=false">OK</button>
      </div>
    </div>
    <b-row align-v="center" class="mb-2">
      <label :class="rootClass + '__search-subscriber-label'"
      >Số thuê bao</label
      >
      <b-input-group :class="[rootClass + '__search-input-group',inputErr?'inputErr':'']">
        <b-input-group-prepend :class="rootClass + '__search-icon'">
          <feather-icon icon="SearchIcon" size="21"/>
        </b-input-group-prepend>
        <b-form-input
            ref="inputSearchPhone"
            v-model="searchPhoneInput"
            :class="rootClass + '__search-input'"
            placeholder="Tìm kiếm"
            size="lg"
            v-on:keyup.enter="searchSubscriberHistory(searchPhoneInput)"

        >
        </b-form-input>
      </b-input-group>
      <b-button :class="rootClass + '__search-btn'" class="redButton" variant="danger"
                @click="searchSubscriberHistory(searchPhoneInput)"
      >Tra cứu
      </b-button
      >
    </b-row>
    <b-row>
      <table :class="rootClass + '__search-table'" class="data">
        <tr style="height: 3rem">
          <template v-for="(h, i) in fields"
          >
            <th
                :key="h.key"
                :class="{
                  '--first-th': i === 0,
                  '--last-th': i === fields.length - 1,
                }"
            >
              {{ h.label }}
            </th>
          </template
          >
        </tr>
        <template v-for="(r,index) in subscriberHistory" v-if="showErrSearch===false">
          <tr
              v-if="index<perPage*currentPage&&index>=perPage*(currentPage-1)"
              :key="index"
              style="height: 3rem; border-top: 0.629766px solid #efefef"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ r.THOIGIAN }}</td>
            <td>{{ r.MA_DV }}</td>
            <td :style="r.THAO_TAC === '1' ? ' color:Green' : 'color: red'">
              <div class="d-flex ">
                <img v-if="r.THAO_TAC === '1'"
                     class="mx-1" src="@/assets/images/icons/icon-tick.png" style="width: 25px; height: 25px;">
                <div v-else
                     class="mx-1"
                     style="width: 25px; height: 25px; border:red solid 1px; border-radius: 50%; background-color: red;
                  color: white; display: inline-block">
                  X
                </div>

                {{ r.THAO_TAC === "1" ? "Mở" : "Đóng" }}
              </div>
            </td>
            <td style="text-align: left;padding-left: 2%">{{ r.GHI_CHU }}</td>
            <td>{{ r.NGUOI_DUNG }}</td>
            <td>{{ r.SO_MSIN_CU }}</td>
            <td>{{ r.SO_MSIN_MOI }}</td>
            <td>{{ r.MA_TINH_CU }}</td>
            <td>{{ r.MA_TINH_MOI }}</td>
          </tr>
        </template>
        <tr v-if="showErrSearch">
          <td></td>
          <td></td>
          <td> Không tìm thấy lịch sử số thuê bao!</td>
        </tr>
      </table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top w-100">
        <b-col class="d-flex align-items-center justify-content-start mb-1 mb-md-0" cols="12"
               md="6">
          <label>Số bản ghi</label>
          <v-select
              v-model="perPage"
              :clearable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
              style="min-width:60px"
          />
          <label>trong 1 trang. Tổng số bản ghi: {{ subscriberHistory.length }}</label>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-end mb-1 mb-md-0" cols="12"
               md="6">
          <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows"/>
        </b-col>
      </b-row>
    </b-row>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "SearchListHistory",
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    DropMenu,
  },
  data() {
    return {
      rootClass: "search-package",
      fields: [
        {key: "stt", label: "STT"},
        {key: "time", label: "Thời gian"},
        {key: "MA_DV", label: "Mã dịch vụ"},
        {key: "THAO_TAC", label: "Thao tác"},
        {key: "GHI_CHU", label: "Ghi chú"},
        {key: "NGUOI_DUNG", label: "Người dùng"},
        {key: "SO_MSIN_CU", label: "MSIN cũ"},
        {key: "SO_MSIN_MOI", label: "MSIN mới"},
        {key: "MA_TINH_CU", label: "Tỉnh cũ"},
        {key: "MA_TINH_MOI", label: "Tỉnh mới"},
      ],
      subscriberHistory: {},
      searchPhoneInput: "",
      regex087: /87\d{7}$/,
      inputErr: false,
      showErrSearch: false,
      perPage: 20,
      perPageOptions: [10, 20, 30, 40],
      currentPage: 1,
      totalRows: 0,
      isShowErrNoti: false,
      notiContent: "",
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    this.searchPhoneInput = this.searchPhone
    this.searchSubscriberHistory(this.searchPhone)
  },
  methods: {
    formatPhoneNum() {
      console.log(this.searchPhoneInput)
      if (this.searchPhoneInput.startsWith("0")) {
        this.searchPhoneInput = this.searchPhoneInput.substring(1);
        this.searchPhoneInput = 84 + this.searchPhoneInput;
        this.searchPhone = this.searchPhoneInput;
      }
      if (this.searchPhoneInput.startsWith("84")) {
        this.searchPhone = this.searchPhoneInput;
      }
    },
    searchSubscriberHistory(searchPhone) {
      this.formatPhoneNum()
      this.showLoading("block")
      if (this.regex087.test(searchPhone)) {
        this.inputErr = false;
        useJwt.get('get-subscriber-history/' + searchPhone).then((response) => {
          this.subscriberHistory = response.data.result.result;
          this.showLoading("none")
          if (this.subscriberHistory.length === 0) {
            this.totalRows = 0
            this.showErrSearch = true
            this.isShowErrNoti = true
            this.notiContent = "Không có lịch sử"
          } else {
            this.totalRows = this.subscriberHistory.length
            this.showErrSearch = false
          }
        }).catch((error) => {
          this.showLoading("none")
          console.log(error);
          this.isShowErrNoti = true
          this.notiContent = "Không lấy được dữ liệu"
        });
      } else {
        this.showLoading("none")
        this.$refs.inputSearchPhone.focus()
        this.subscriberHistory = {}
        if (this.searchPhoneInput === "") {
          this.isShowErrNoti = true
          this.notiContent = "Vui lòng nhập số điện thoại"
        } else {
          this.isShowErrNoti = true
          this.notiContent = "Số thuê bao không hợp lệ"
        }
        this.inputErr = true
      }
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    }
  }
}
</script>

<style lang="scss">@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss" scoped>

.search-package {
  color: black;
  font-family: "Times New Roman";
  font-size: 16px;
  font-weight: 500;
  min-height: 500px;

  &__card {
    border-radius: 2rem;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-package-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__search-subscriber-label {
    margin-right: 1rem;
    color: black;
    font-size: 14px;
    font-weight: 500;
  }

  &__search-input-group {
    width: 200px;
    margin-right: 3rem;
  }

  &__search-icon {
    position: absolute;
    z-index: 4;
    top: 50%;
    left: 1rem;
    transform: translate(0%, -50%);
  }

  &__search-input {
    padding-left: 3rem;
    border: 1.125px solid #e1e1e1 !important;
    border-radius: 6px !important;
  }

  &__search-btn {
    border-radius: 40px !important;
    color: white;
  }

  &__search-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;
  }

  &__menu-right-group {
    position: absolute;
    top: 140px;
    right: 20px;
  }
}

.inputErr {
  border: 1px red solid;
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

tr th,
tr td {
  border: 0.299185px solid rgba(184, 184, 184, 0.5);
  //border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
}

tr td {
  color: black;
}

th {
  background-color: #ED1F24;
  color: white;
}

.errMsg {
  padding: 1%;
  height: 300px;
  width: 445px;
  position: fixed;
  background-color: white;
  z-index: 10;
  top: 30%;
  left: 35%;
  border-radius: 13.24px;
  box-shadow: 5px 10px 18px #888888;
}

.buttonOK {
  width: 164.88px;
  height: 44.17px;
  left: 638px;
  top: 400px;
  background: #ED1F24;
  border-radius: 23.6547px;
  border-color: #ED1F24;
  color: white;
}

@media screen and (max-width: 576px) {
  .search-package {
    &__subscriber-information-btn {
      font-size: 12px;
    }

    &__search-package-btn {
      font-size: 12px;
    }

    &__search-subscriber-label {
      width: 100%;
    }

    &__search-input-group {
      margin-right: 1rem;
      width: 170px;
    }

    &__search-table {
      font-size: 8px;
    }
  }
}

</style>
